module.exports = __webpack_public_path__ + "assets/img/Winning-grand-prize.1ba35c70.png";